<div class="page-table-filter wrapper--spacing-horizontal">
  <h1 class="text--h1">{{ 'gbm.title' | translate }}</h1>

  <agr-table-v2
    matSort
    [dataSource]="dataSource"
    [isEqual]="isEqual"
    [withSelection]="true"
    (filterClearClick)="resetFilters()"
    class="gbm-overview__table-spaced-cols"
  >
    <ng-container *agrTableSearch [formGroup]="searchAndFilters">
      <agr-table-search
        formControlName="search"
        [label]="'search' | translate"
        [placeholder]="'gbm.search-placeholder' | translate"
      >
      </agr-table-search>
    </ng-container>

    <ng-container *agrTableFilters [formGroup]="searchAndFilters">
      <agr-table-multi-select-filter
        agrTableFilterLocations
        [label]="'page-hierarchical-data-filter.locations' | translate"
        formControlName="locations"
      >
      </agr-table-multi-select-filter>

      <agr-table-date-range-filter
        [label]="'daterange-picker.period' | translate"
        [config]="dateRangeConfig"
        formControlName="dateRange"
      >
      </agr-table-date-range-filter>
    </ng-container>

    <agr-table-top-bar *agrTableTopBar class="gbm-overview__top-bar">
      <agr-table-selected-items></agr-table-selected-items>
      <div
        class="flex--row flex--gutter flex--nowrap flex--align-center flex--justify-space-between"
      >
        <mat-slide-toggle
          color="primary"
          [formControl]="showTotalsToggle"
          [attr.data-test]="'filter__item-showTotals'"
        >
          {{ 'page-table-filter.show-totals' | translate }}
        </mat-slide-toggle>
        <agr-export agrTableExport [options]="exportOptions" [dataSource]="dataSource">
        </agr-export>
      </div>
    </agr-table-top-bar>

    <ng-container matColumnDef="deliveryDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'gbm.gbm-overview.deliveryDate' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'gbm.gbm-overview.deliveryDate' | translate"
        *matCellDef="let row"
      >
        {{ row.deliveryDate | agrDate: 'shortDate' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="externalProductId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'gbm.gbm-overview.externalProductId' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'gbm.gbm-overview.externalProductId' | translate"
        *matCellDef="let row"
      >
        {{ row.externalProductId }}
      </td>
    </ng-container>

    <ng-container matColumnDef="productTitle">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'gbm.gbm-overview.productTitle' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'gbm.gbm-overview.productTitle' | translate"
        *matCellDef="let row"
      >
        {{ row.productTitle }}
      </td>
    </ng-container>

    <ng-container matColumnDef="unitQuantity">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'gbm.gbm-overview.unitQuantity' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'gbm.gbm-overview.unitQuantity' | translate"
        *matCellDef="let row"
      >
        {{ row.unitQuantity | agrNumber }}
      </td>
    </ng-container>

    <ng-container matColumnDef="gbmBaseUnit">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'gbm.gbm-overview.gbmBaseUnit' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'gbm.gbm-overview.gbmBaseUnit' | translate"
        *matCellDef="let row"
      >
        {{ row.gbmBaseUnit }}
      </td>
    </ng-container>

    <ng-container matColumnDef="productQuantity">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'gbm.gbm-overview.productQuantity' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'gbm.gbm-overview.productQuantity' | translate"
        *matCellDef="let row"
      >
        {{ row.productQuantity | agrNumber }}
      </td>
    </ng-container>

    <ng-container matColumnDef="unitVolumeType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'gbm.gbm-overview.unitVolumeType' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'gbm.gbm-overview.unitVolumeType' | translate"
        *matCellDef="let row"
      >
        {{ row.unitVolumeType }}
      </td>
    </ng-container>

    <ng-container matColumnDef="allShipToIds">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'gbm.gbm-overview.allShipToIds' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'gbm.gbm-overview.allShipToIds' | translate"
        *matCellDef="let row"
      >
        <agr-identifier-trigger
          [data]="row.allShipToIds"
          [hideDescription]="true"
          [onlyUnique]="true"
          (click)="$event.stopPropagation()"
        ></agr-identifier-trigger>
      </td>
    </ng-container>

    <ng-container matColumnDef="externalDeliveryId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'gbm.gbm-overview.externalDeliveryId' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'gbm.gbm-overview.externalDeliveryId' | translate"
        *matCellDef="let row"
      >
        {{ row.externalDeliveryId }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>{{ 'table.action' | translate }}</th>
      <td
        mat-cell
        [attr.aria-label]="'gbm.gbm-overview.externalDeliveryId' | translate"
        *matCellDef="let row"
      >
        <button mat-button (click)="openMSDS(row)">
          <mat-icon class="action-icon">info</mat-icon>
          <span>{{ 'gbm.gbm-overview.msds' | translate }}</span>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let myRowData; columns: displayColumns"></tr>
    <tr *matNoDataRow>
      <td class="text--center" [attr.colspan]="displayColumns.length">
        <agr-notification-empty
          data-test="hierarchical-data__empty"
          [isEmpty]="true"
          [emptyTitle]="'gbm.empty-title' | translate"
          [emptyDescription]="'gbm.empty-description' | translate"
          [emptyImage]="'/assets/images/no-items-3.png'"
          [emptyActionIcon]="'history'"
          [emptyActionText]="'page-table-filter.reset-filters' | translate"
          [showEmptyAction]="true"
          (emptyAction)="resetFilters()"
          class="spacing--margin-top"
        ></agr-notification-empty>
      </td>
    </tr>
  </agr-table-v2>
</div>
